import React, { Component } from 'react';
import Card from '../../ui/Card';
import { AlertTriangleIcon, TrendingDownIcon, AlertCircleIcon, XCircleIcon } from 'lucide-react';
const TopRisksPanel: React.FC = () => {
  const risks = [{
    rank: 1,
    category: 'Financial',
    risk: 'Material Cost Inflation',
    severity: 'Critical',
    impact: '₹185 Cr',
    probability: '85%',
    riskScore: 9.2,
    mitigation: 'Supplier negotiations, alternate sourcing, hedging strategies',
    owner: 'CFO',
    timeline: 'Immediate',
    color: 'bg-red-100 border-red-300 text-red-800',
    icon: <AlertTriangleIcon size={18} data-id="element-3583" />
  }, {
    rank: 2,
    category: 'Operational',
    risk: 'Plant Capacity Constraint - Chennai',
    severity: 'High',
    impact: '₹142 Cr revenue loss',
    probability: '75%',
    riskScore: 8.5,
    mitigation: 'Weekend shifts, capex for line expansion, outsourcing',
    owner: 'COO',
    timeline: 'Q4 FY24',
    color: 'bg-red-100 border-red-300 text-red-800',
    icon: <XCircleIcon size={18} data-id="element-3584" />
  }, {
    rank: 3,
    category: 'Market',
    risk: 'Customer Concentration Risk',
    severity: 'High',
    impact: '₹1,710 Cr exposure',
    probability: '60%',
    riskScore: 8.0,
    mitigation: 'New customer acquisition, product diversification',
    owner: 'CSO',
    timeline: 'FY25',
    color: 'bg-orange-100 border-orange-300 text-orange-800',
    icon: <TrendingDownIcon size={18} data-id="element-3585" />
  }, {
    rank: 4,
    category: 'Quality',
    risk: 'Warranty Cost Escalation - LED Headlamps',
    severity: 'High',
    impact: '₹52 Cr additional cost',
    probability: '70%',
    riskScore: 7.8,
    mitigation: 'Root cause analysis, supplier audit, design review',
    owner: 'CQO',
    timeline: 'Q3 FY24',
    color: 'bg-orange-100 border-orange-300 text-orange-800',
    icon: <AlertCircleIcon size={18} data-id="element-3586" />
  }, {
    rank: 5,
    category: 'Supply Chain',
    risk: 'Single Source Dependency - Critical Components',
    severity: 'Medium',
    impact: '₹95 Cr production loss',
    probability: '55%',
    riskScore: 7.2,
    mitigation: 'Dual sourcing strategy, buffer inventory',
    owner: 'SCM Head',
    timeline: 'Q1 FY25',
    color: 'bg-yellow-100 border-yellow-300 text-yellow-800',
    icon: <AlertCircleIcon size={18} data-id="element-3587" />
  }, {
    rank: 6,
    category: 'Regulatory',
    risk: 'Environmental Compliance - New Emission Norms',
    severity: 'Medium',
    impact: '₹78 Cr compliance cost',
    probability: '90%',
    riskScore: 7.0,
    mitigation: 'Technology upgrade, process modification',
    owner: 'EHS Head',
    timeline: 'H2 FY24',
    color: 'bg-yellow-100 border-yellow-300 text-yellow-800',
    icon: <AlertCircleIcon size={18} data-id="element-3588" />
  }, {
    rank: 7,
    category: 'Operational',
    risk: 'Skilled Labor Shortage',
    severity: 'Medium',
    impact: '₹65 Cr productivity loss',
    probability: '65%',
    riskScore: 6.8,
    mitigation: 'Training programs, automation, competitive compensation',
    owner: 'CHRO',
    timeline: 'Ongoing',
    color: 'bg-yellow-100 border-yellow-300 text-yellow-800',
    icon: <AlertCircleIcon size={18} data-id="element-3589" />
  }, {
    rank: 8,
    category: 'Technology',
    risk: 'IT Infrastructure Obsolescence',
    severity: 'Medium',
    impact: '₹48 Cr upgrade cost',
    probability: '80%',
    riskScore: 6.5,
    mitigation: 'Phased modernization, cloud migration',
    owner: 'CIO',
    timeline: 'FY25-26',
    color: 'bg-yellow-100 border-yellow-300 text-yellow-800',
    icon: <AlertCircleIcon size={18} data-id="element-3590" />
  }, {
    rank: 9,
    category: 'Market',
    risk: 'EV Transition Impact on Traditional Products',
    severity: 'Medium',
    impact: '₹320 Cr revenue shift',
    probability: '75%',
    riskScore: 6.2,
    mitigation: 'EV component development, R&D investment',
    owner: 'CTO',
    timeline: 'FY25-27',
    color: 'bg-yellow-100 border-yellow-300 text-yellow-800',
    icon: <TrendingDownIcon size={18} data-id="element-3591" />
  }, {
    rank: 10,
    category: 'Financial',
    risk: 'Foreign Exchange Volatility',
    severity: 'Low',
    impact: '₹42 Cr exposure',
    probability: '70%',
    riskScore: 5.8,
    mitigation: 'Natural hedging, forward contracts',
    owner: 'Treasury Head',
    timeline: 'Ongoing',
    color: 'bg-green-100 border-green-300 text-green-800',
    icon: <AlertCircleIcon size={18} data-id="element-3592" />
  }];
  return <Card className="p-6 bg-gradient-to-br from-red-50 to-white border-2 border-red-100" data-id="element-3593">
      <div className="flex items-center justify-between mb-4" data-id="element-3594">
        <div data-id="element-3595">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-3596">Top 10 Risks</h3>
          <p className="text-sm text-gray-600" data-id="element-3597">
            Critical risks requiring executive attention
          </p>
        </div>
        <div className="text-right" data-id="element-3598">
          <div className="text-3xl font-bold text-red-600" data-id="element-3599">10</div>
          <div className="text-xs text-gray-600" data-id="element-3600">Active Risks</div>
        </div>
      </div>
      <div className="space-y-3 max-h-[600px] overflow-y-auto" data-id="element-3601">
        {risks.map((risk, index) => <div key={index} className={`${risk.color} border-2 rounded-lg p-4`} data-id="element-3602">
            <div className="flex items-start justify-between mb-2" data-id="element-3603">
              <div className="flex items-start flex-1" data-id="element-3604">
                <div className="flex items-center justify-center w-8 h-8 rounded-full bg-white/50 mr-3 font-bold text-sm" data-id="element-3605">
                  #{risk.rank}
                </div>
                <div className="flex-1" data-id="element-3606">
                  <div className="flex items-center mb-1" data-id="element-3607">
                    <span className="text-xs font-semibold px-2 py-0.5 bg-white/50 rounded mr-2" data-id="element-3608">
                      {risk.category}
                    </span>
                    <span className="text-xs font-bold" data-id="element-3609">{risk.severity}</span>
                    <span className="mx-2" data-id="element-3610">•</span>
                    <span className="text-xs" data-id="element-3611">Score: {risk.riskScore}</span>
                  </div>
                  <div className="font-bold text-sm mb-1" data-id="element-3612">{risk.risk}</div>
                  <div className="text-xs mb-2" data-id="element-3613">
                    <span className="font-semibold" data-id="element-3614">Impact:</span> {risk.impact}{' '}
                    | <span className="font-semibold" data-id="element-3615">Probability:</span>{' '}
                    {risk.probability}
                  </div>
                </div>
              </div>
              <div className="ml-2" data-id="element-3616">{risk.icon}</div>
            </div>
            <div className="pt-2 border-t border-current/20" data-id="element-3617">
              <div className="text-xs mb-1" data-id="element-3618">
                <span className="font-semibold" data-id="element-3619">Mitigation:</span>{' '}
                {risk.mitigation}
              </div>
              <div className="flex items-center justify-between text-xs" data-id="element-3620">
                <span data-id="element-3621">
                  <span className="font-semibold" data-id="element-3622">Owner:</span> {risk.owner}
                </span>
                <span data-id="element-3623">
                  <span className="font-semibold" data-id="element-3624">Timeline:</span>{' '}
                  {risk.timeline}
                </span>
              </div>
            </div>
          </div>)}
      </div>
      <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-3625">
        <div className="grid grid-cols-4 gap-4 text-sm" data-id="element-3626">
          <div className="text-center" data-id="element-3627">
            <div className="text-gray-600" data-id="element-3628">Total Risk Exposure</div>
            <div className="text-xl font-bold text-red-600" data-id="element-3629">₹1,027 Cr</div>
          </div>
          <div className="text-center" data-id="element-3630">
            <div className="text-gray-600" data-id="element-3631">Critical Risks</div>
            <div className="text-xl font-bold text-red-600" data-id="element-3632">2</div>
          </div>
          <div className="text-center" data-id="element-3633">
            <div className="text-gray-600" data-id="element-3634">High Risks</div>
            <div className="text-xl font-bold text-orange-600" data-id="element-3635">3</div>
          </div>
          <div className="text-center" data-id="element-3636">
            <div className="text-gray-600" data-id="element-3637">Avg Risk Score</div>
            <div className="text-xl font-bold text-gray-900" data-id="element-3638">7.2</div>
          </div>
        </div>
      </div>
    </Card>;
};
export default TopRisksPanel;